// extracted by mini-css-extract-plugin
export default {"container":"BatteryStatusCodes_container__bW2pg"};